export const CRUK = {
    contact_card: {
        showPrices: {
            title: 'Your Details',
            form_title: 'Check prices',
            subtitle:
        'Please enter your details and we’ll show you our best price and email a personalised quote.',
        },
        contactMe: {
            title: 'Send Quote',
            submit_text: 'Send Quote',
        },
        emailOverride: 'admin@ukstoragecompany.co.uk',
    },
    cta: {
        select: 'Select',
        continue: 'Select',
        enquire_now: 'Select',
        step_3: {
            continue: 'Select',
        },
        call_us_now: 'LIMITED AVAILABILITY - <b>CALL US NOW</b>',
    },
    wizard: {
        termsAndConditionsAgree:
      'I confirm that I have read and acknowledge the FULL terms and conditions above, including the key conditions, and I agree to be bound by them.',
        insuranceCoverage: {
            title: 'StoreProtect',
            subtitle:
        'Insurance is not included with our rent charges. We highly recommend that all customers insure their goods for peace of mind.',
            noInsuranceSelected: 'No Protection Selected',
        },
        autobillDetails: {
            bsbNumber: 'Sort Code',
            none: 'Non UK Bank Account',
            switchToDebit:
        'Please note: A £7.20 fee applies to all future rental payments not made via Direct Debit.',
        },
        alternateContactDetails: {
            title: 'Next of Kin Details',
        },
        pricingTable: {
            tax: 'VAT',
        },
    },
    unit_listing: {
        unit_unavailable_at_move_in:
      'We currently have limited availability, please call us on 0330 202 0602 to confirm your booking.',
    },
    locations: {
        BW: 'Bridgwater',
        TA: 'Taunton',
        B1: 'Bristol West',
        PL: 'Plymouth North',
        B2: 'Bristol Central',
        CH: 'Chard',
        GL: 'Gloucester',
        RR: 'Redruth',
        SW: 'Swindon',
        P2: 'Plymouth Central',
        WM: 'Weston Super Mare',
        YE: 'Yeovil',
        BN: 'Barnstaple',
        FH: 'Fareham',
        KM: 'Kidderminster',
        WC: 'Worcester',
        MK: 'Milton Keynes',
        WG: 'Wigan',
        LP: 'Liverpool',
        WR: 'Warrington',
        SD: 'Swadlincote',
        BT: 'Burton Upon Trent',
        LD: 'Leeds',
        ST: 'Stoke On Trent',
        TF: 'Telford',
        RG: 'Rugby',
        SF: 'Sheffield',
        YT: 'Yate',
        WT: 'Witney',
    },
    errors: {
        10001:
      'We currently have limited availability, please call us on 0330 202 002 to confirm your booking.',
    },
};
